import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Userinterfaceuna() {
  return (
    <section
      className="userinterface_una p-100 text_white text_white_una"
      style={{ background: "#004343" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center resp_order"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/una/user_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={655}
                height={768}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <h2>
              <strong>UNA User Interface</strong>
              <br /> A Sleek Modern Design And Fun Interface
            </h2>
            <p>
              The UNA Job Portal app was designed with the students in mind.
              Tekrevol knew the app needed to be appealing and have interactive
              features to increase the customer base. We chose to make the job
              board a combination of minimalistic design and whitespace. The
              whitespaces were added to make the interface look neat to aid the
              students in completing their tasks. We also added job categories
              so that students didn't have to browse through a variety of jobs.
              They could just go to the homepage, click a category, and apply
              for suitable jobs.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Userinterfaceuna;
